<template>
  <div class="bloque-wrapper d-flex" :class="{ 'bloque-simple': simple }">
    <v-card
      class="bloque-card flex-grow-1"
      :class="{ 'bloque-card-simple': simple }"
      :outlined="!simple"
      :flat="simple"
    >
      <v-chip v-if="!simple" class="nombre-chip px-5" color="#FF9C00" text-color="#191970">
        <v-icon left small>{{ icono }}</v-icon>
        <span class="nombre-chip-text">{{ bloque.nombre }}</span>
      </v-chip>

      <div v-if="bloque.detalle || bloque.fecha" class="detalle-bloque px-4">
        <span v-if="bloque.detalle">{{ bloque.detalle }}</span>
        <span v-if="bloque.detalle && bloque.fecha" aria-hidden="true"> · </span>
        <span v-if="bloque.fecha">{{ formatearFecha(bloque.fecha) }}</span>
      </div>

      <v-card-text
        class="preguntas-container pa-4 pa-sm-5"
        :class="{ 'sin-detalle': !simple && !bloque.detalle && !bloque.fecha }"
      >
        <div
          v-for="(pregunta, preguntaIndex) in bloque.preguntas"
          :key="pregunta.id"
          class="pregunta"
          :class="{ 'mt-7 pt-7 pregunta-separada': preguntaIndex > 0 }"
        >
          <p class="pregunta-texto mb-2">{{ pregunta.pregunta }}</p>

          <div class="valoracion-wrapper">
            <div class="puntuacion-linea d-flex align-center">
            <v-rating
              :value="puntuacion(pregunta)"
              :length="10"
              size="25"
              color="#FFC107"
              background-color="#C7C7C0"
              empty-icon="mdi-star-outline"
              full-icon="mdi-star"
              half-icon="mdi-star-half-full"
              dense
              hover
              clearable
              :aria-label="pregunta.pregunta"
              @input="puntuar(pregunta, $event)"
            />
              <v-chip
                  v-if="puntuacion(pregunta)"
                  x-small
                  color="#FFF0B3"
                  text-color="#725A00"
                  class="puntuacion-chip ml-2 font-weight-bold"
                >
                  {{ puntuacion(pregunta) }}/10
                </v-chip>
            </div>
          </div>

          <v-expand-transition>
            <v-textarea
              v-if="pregunta.permite_comentario && puntuacion(pregunta)"
              :value="pregunta.respuesta.comentario"
              :label="pregunta.pregunta_comentario || $t('mensajes.cuestionario.comentario')"
              outlined
              dense
              auto-grow
              rows="1"
              maxlength="5000"
              hide-details
              @input="comentar(pregunta, $event)"
            />
          </v-expand-transition>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'CuestionarioBloque',

  props: {
    bloque: {
      type: Object,
      required: true,
    },
    simple: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    icono() {
      if (this.bloque.tipo === 'alojamiento') return 'mdi-bed-outline';
      if (this.bloque.tipo === 'servicio') return 'mdi-compass-outline';
      return 'mdi-heart-outline';
    },
  },

  methods: {
    puntuacion(pregunta) {
      return Number(pregunta.respuesta.puntuacion) || 0;
    },

    puntuar(pregunta, valor) {
      this.$emit('puntuar', {
        pregunta,
        puntuacion: Number(valor) || null,
      });
    },

    comentar(pregunta, comentario) {
      this.$emit('comentar', { pregunta, comentario });
    },

    formatearFecha(fecha) {
      if (!fecha) return '';
      const partes = String(fecha).substring(0, 10).split('-');
      if (partes.length !== 3) return fecha;
      const date = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]));
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      }).format(date);
    },
  },
};
</script>

<style scoped>
.bloque-wrapper {
  position: relative;
  width: 100%;
  padding-top: 18px;
}

.bloque-wrapper.bloque-simple {
  padding-top: 0;
}

.bloque-card {
  position: relative;
  overflow: visible;
  border: 2px solid #ff9c00 !important;
  border-radius: 18px !important;
  background-color: #fff;
}

.bloque-card-simple {
  border: 0 !important;
  border-radius: 0 !important;
  background-color: transparent !important;
}

.nombre-chip {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 18px;
  max-width: calc(100% - 32px);
  border-radius: 18px !important;
  transform: translateY(-50%);
}

.nombre-chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detalle-bloque {
  min-height: 34px;
  margin-top: 29px;
  color: #6b6b66;
  font-size: 0.78rem;
  font-weight: 700;
}

.preguntas-container {
  padding-top: 10px !important;
}

.preguntas-container.sin-detalle {
  padding-top: 42px !important;
}

.pregunta-separada {
  border-top: 1px solid #deded7;
}

.pregunta-texto {
  color: #30302d;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.35;
}

.valoracion-wrapper {
  overflow-x: auto;
}

.valoracion-wrapper ::v-deep .v-rating {
  white-space: nowrap;
}

.valoracion-wrapper ::v-deep .v-rating .v-icon {
  padding: 2px;
}

.puntuacion-linea {
  width: max-content;
  min-width: 100%;
}

.puntuacion-chip {
  flex: 0 0 auto;
}

.pregunta ::v-deep .v-textarea textarea {
  line-height: 1.35;
  min-height: 28px;
}

@media (max-width: 380px) {
  .valoracion-wrapper ::v-deep .v-rating .v-icon {
    font-size: 22px !important;
    padding: 1px;
  }
}
</style>
